// extracted by mini-css-extract-plugin
module.exports = {"MiniLoader":"ShowMiniLoader_MiniLoader__3f3oh","TransparentBg":"ShowMiniLoader_TransparentBg__2j0MI","DropdownLoader":"ShowMiniLoader_DropdownLoader__3AivM"};